var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { useTheme } from 'styled-components';
import Skeleton from '../../Progress/Skeleton/Skeleton';
import { useCronoSkeleton } from '../../Boost/CronoSkeleton';
import Chip from '../Chip/Chip';
const ChipsStyle = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  margin-right: ${props => props.noMargin ? '-' + props.theme.paddingsMargins.themeMenuMarginSingle : null};
`;
const Chips = (_a) => {
    var { secondary = false, noPadding = false, values = [], hashtag = false, canDelete = true, onDeleteChip = () => { }, color = '', textColor = 'white', isFull = true, isLoading = false, skeleton, repetitionsSkeleton = 1, excludeMeFromLoadingContext = false, fontSize = 'subArticle', noMargin = false } = _a, props = __rest(_a, ["secondary", "noPadding", "values", "hashtag", "canDelete", "onDeleteChip", "color", "textColor", "isFull", "isLoading", "skeleton", "repetitionsSkeleton", "excludeMeFromLoadingContext", "fontSize", "noMargin"]);
    const { loadingContext } = useCronoSkeleton();
    const theme = useTheme();
    return ((loadingContext && excludeMeFromLoadingContext === false) || isLoading
        ? _jsx(Skeleton, { margin: "v", width: "250px", height: "30px", repetition: repetitionsSkeleton, direction: "h" })
        : _jsx(ChipsStyle, Object.assign({}, props, { noMargin: noMargin }, { children: values.map((value, i) => {
                return (_jsx(Chip, Object.assign({ textColor: textColor, isFull: isFull, secondary: secondary, fontSize: fontSize, canDelete: canDelete, style: {
                        marginLeft: noMargin ? 0 : theme.paddingsMargins.themeMenuMarginSingle,
                        marginRight: theme.paddingsMargins.themeMenuMarginSingle,
                        marginTop: noMargin ? 0 : theme.paddingsMargins.themeMenuMarginSingle,
                        marginBottom: theme.paddingsMargins.themeMenuMarginSingle
                    }, noPadding: noPadding, index: i, onDeleteChip: onDeleteChip, color: color }, { children: `${hashtag ? '#' : ''}${value}` }), i));
            }) })));
};
export default Chips;
